export const noop = () => {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	return {} as any;
};
